import { addError, resetError } from './error';
import api from "../../helpers/apiClient";
import { getDeviceToken, saveDeviceToken } from '../../helpers/trustedDevice';

export const REQUEST_LOGIN = 'REQUEST_LOGIN';
export const SUCCESS_LOGIN = 'SUCCESS_LOGIN';
export const FAILED_LOGIN = 'FAILED_LOGIN';
export const CODE_REQUIRED = 'CODE_REQUIRED';
export const UPDATE_TOKEN = 'UPDATE_TOKEN';

export const LOGOUT = 'LOGOUT';
export const SET_REDIRECT = 'SET_REDIRECT';
// const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
// const LOGOUT_FAIL = 'LOGOUT_FAIL';

function postLogin(email, password) {
  return (dispatch, getState) => {
    dispatch(requestLogin());
    return api('/auth/login', {
      method: "post",
      body: JSON.stringify({ email, password, deviceToken: getDeviceToken(email) })
    })
    .then(json => {
      if (json && json.twoFactorRequired) {
        dispatch(codeRequired());
        dispatch(resetError());
        return json;
      }
      return dispatch(completeLogin(json));
    })
    .catch((err) => {
      dispatch(failedLogin());
      dispatch(addError(err.message));
    });
  };
}

// Stores the session and returns the path to send the user to
function completeLogin(json) {
  return (dispatch, getState) => {
    const { auth } = getState();
    dispatch(successLogin(json));
    dispatch(resetError());

    if (auth.redirect) {
      return auth.redirect;
    }

    if(json && json.user && json.user.role === 'merchant-staff'){
      return '/orders'
    } else {
      return '/'
    }
  };
}

function shouldPostLogin(state, email, password) {
  if (!email || !password) return false;

  const result = state.auth;
  if (result && result.loading) {
    return false;
  } else {
    return true;
  }
}

function requestLogin() {
  return {
    type: REQUEST_LOGIN
  };
}

function successLogin(json) {
  return {
    type: SUCCESS_LOGIN,
    payload: {
      user: {
        ...json.user,
        token: json.token,
      },
      receivedAt: Date.now(),
    }
  };
}

function failedLogin() {
  return {
    type: FAILED_LOGIN
  };
}

function codeRequired() {
  return {
    type: CODE_REQUIRED
  };
}

// Swaps in the token the server issues after a password change, which logs out older sessions
export function updateToken(token) {
  return {
    type: UPDATE_TOKEN,
    payload: {
      token
    }
  };
}

function logUserOut(redirect) {
  return {
    type: LOGOUT,
    payload: {
      redirect,
    }
  }
}

export function login(email, password, done) {
  return (dispatch, getState) => {
    return dispatch(postLogin(email, password)).then(result => {
      // The login page shows the security code step instead of navigating
      if (result && result.twoFactorRequired) {
        return result;
      }
      done(result)
    });
    // if (shouldPostLogin(getState(), email, password)) {

    // }
  };
}

// Rejects with the server's { message } when the code is wrong or expired
export function verifyCode(email, code, rememberDevice, done) {
  return (dispatch) => {
    return api('/auth/verify-code', {
      method: "post",
      body: JSON.stringify({ email, code, rememberDevice })
    })
    .then(json => {
      if (json.deviceToken) {
        saveDeviceToken(email, json.deviceToken);
      }
      done(dispatch(completeLogin(json)));
    });
  };
}

export function logout(done, redirect = false){
  return (dispatch, getState) => {
    done('/login')
    dispatch(logUserOut(redirect));
  }
}

function setLoginRedirect(link) {
  return {
    type: SET_REDIRECT,
    payload: {
      redirect: link
    }
  }
}

export function setRedirect(link) {
  return (dispatch) => {
    dispatch(setLoginRedirect(link));
  }
}
